import React from 'react'

import {
  DateCombobox as DateComboboxBase,
  type DateComboboxProps as DateComboboxBaseProps,
} from '@/components/common/ComboboxV2/DateCombobox'

interface DateSelectProps extends Omit<
  DateComboboxBaseProps,
  'open' | 'setOpen' | 'dialogConfig' | 'customDates'
> {}

export const DateSelect: React.FC<DateSelectProps> = ({ ...props }) => {
  const [open, setOpen] = React.useState(false)
  return (
    <DateComboboxBase
      open={open}
      setOpen={setOpen}
      dialogConfig={{ allowNull: false }}
      customDates={[
        {
          label: 'In one month',
          value: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
        },
      ]}
      {...props}
    />
  )
}
